import {Messages} from '../../constants';

const validation = {
  diaDeVencimento: {
    presence: {
      message: Messages.RequiredExpirationDayValidationRequiredMessage,
      allowEmpty: false,
    },
    numericality: {
      greaterThan: 0,
    },
  },
  embossing: {
    presence: {
      message: Messages.RequiredEmbossingValidationMessage,
      allowEmpty: false,
    },
    length: {
      maximum: 19,
      message: Messages.EmbossingValidationTooLong,
    },
    format: {
      pattern: /(\w.+\s).+/i,
      message: Messages.RequiredEmbossingFullValidationRequiredMessage,
    },
  },
};

export default validation;
